<template>
  <ContainerLayout class="tw:flex-col">
    <div class="tw:mr-auto tw:ml-auto tw:pt-6 tw:pb-12 tw:w-full">
      <ReadMoreContainer />
    </div>
  </ContainerLayout>
  <RateConnectNotEligibleFaq :isBlockedCountry="false" />
</template>
<script setup lang="ts">
import ContainerLayout from '@/layouts/ContainerLayout.vue'
import ReadMoreContainer from '@/components/rateConnect/notEligible/ReadMoreContainer.vue'
import RateConnectNotEligibleFaq from '@/components/rateConnect/notEligible/RateConnectNotEligibleFaq.vue'
</script>
